/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_JoinInputs */

const en_action_join = /** @type {(inputs: Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Community`)
};

const es_action_join = /** @type {(inputs: Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a la Comunidad`)
};

const fr_action_join = /** @type {(inputs: Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la communauté`)
};

const de_action_join = /** @type {(inputs: Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community beitreten`)
};

const id_action_join = /** @type {(inputs: Action_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung Komunitas`)
};

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const ja_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const zh_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const ar_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const it_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const ru_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const pt_action_join = en_action_join;

/** @type {(inputs: Action_JoinInputs) => LocalizedString} */
const ko_action_join = en_action_join;

/**
* | output |
* | --- |
* | "Join Community" |
*
* @param {Action_JoinInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_join = /** @type {((inputs?: Action_JoinInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_JoinInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_join(inputs)
	if (locale === "es") return es_action_join(inputs)
	if (locale === "fr") return fr_action_join(inputs)
	if (locale === "de") return de_action_join(inputs)
	if (locale === "ja") return ja_action_join(inputs)
	if (locale === "zh") return zh_action_join(inputs)
	if (locale === "ar") return ar_action_join(inputs)
	if (locale === "id") return id_action_join(inputs)
	if (locale === "it") return it_action_join(inputs)
	if (locale === "ru") return ru_action_join(inputs)
	if (locale === "pt") return pt_action_join(inputs)
	return ko_action_join(inputs)
});